<template>
  <v-content
    class="ma-0 pa-0"
  >
    <!--      Start Free Trial      -->
        <v-row
        no-gutters
        justify="center"
        >
        <v-btn
            class="btn1 mb-10"
            tile
            outlined
            @click.prevent="signUp"
        >
            START FREE TRIAL
        </v-btn>
        </v-row>

  </v-content>
</template>

<script>

export default {
  components: {

  },

  computed: {

  },

  methods: {
    signUp: function() {
        this.$router.push('/signup');
    },
  }
}
</script>

<style scoped>

  .btn1 {
    /* font-family: "Noto Serif TC", serif; */
    font-size: 1.0em;
    font-weight: 600;
    color: #584f6c;
    text-align: center;
  }

</style>